<template>
  <v-card>
    <!-- <v-card-title>User Login</v-card-title> -->
    <v-list>
      <v-list-tile avatar>
        <v-list-tile-avatar>
          <v-icon large>add</v-icon>
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title>Add Visa Number</v-list-tile-title>
        </v-list-tile-content>

        <v-list-tile-action>
          <v-btn icon fav small outline @click="onCancelled">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
    <v-divider></v-divider>
    <v-card-text style="max-height: 85%">
      <v-form ref="addVisaNumberForm" v-model="valid" lazy-validation>
        <v-layout column>
          <v-flex xs12 pb-4>
            <v-autocomplete
              label="Company *"
              v-model="newItem.employer_id"
              :items="employersTV"
              hide-details
              hide-selected
              item-text="text"
              item-value="value"
              outline
              required
              :rules="requiredRules"
            >
            </v-autocomplete>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              outline
              label="Visa Number *"
              v-model="newItem.visa_no"
              required
              :rules="requiredRules"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              outline
              label="Visa Quantity *"
              v-model="newItem.qty"
              required
              :rules="requiredRules"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="onCancelled">Cancel</v-btn>
      <v-btn
        color="blue"
        @click="newItemDo"
        :disabled="!valid || actionButtonClicked"
        :loading="actionButtonClicked"
        >Add</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import { GENDERS } from "../../mdsir/const";
export default {
  props: ["employersTV"],
  data() {
    return {
      actionButtonClicked: false,
      valid: true,
      newItem: {
        visa_no: "",
        qty: "",
        employer_id: "",
      },
    };
  },
  methods: {
    onCancelled() {
      this.$emit("cancelled");
    },
    onNewItemAdded(addedData) {
      this.$emit("added", addedData);
      this.clearForm();
      this.onCancelled();
    },
    validate() {
      if (this.$refs.addVisaNumberForm.validate()) {
        this.snackbar = true;
      }
    },
    reset() {
      this.$refs.addVisaNumberForm.reset();
    },
    resetValidation() {
      this.$refs.addVisaNumberForm.resetValidation();
    },
    clearForm() {
      this.newItem = {
        visa_no: "",
        qty: "",
        employer_id: "",
      };
    },
    newItemDo() {
      if (this.$refs.addVisaNumberForm.validate()) {
        this.actionButtonClicked = true;
        this.post("/visa_number", this.newItem).then((res) => {
          if (res.data.success) {
            this.onNewItemAdded(res.data.data);
          }
          this.snackbarShow(res.data);
          this.actionButtonClicked = false;
        });
      }
    },
  },
  mounted() {},
  created() {
    this.GENDERS = GENDERS;
  },
};
</script>
